<template>
  <v-card
    class="mx-auto overflow-visible"
    width="500px"
    style="margin-top: 0px; margin-bottom: 0px; z-index: 99"
    outlined
  >
    <div>
      <v-list-item three-line>
        <v-list-item-content class="overflow-visible d-block">
          <v-row class="align-center">
            <v-col cols="10">
              <v-list-item-title class="headline mb-2"
                >Tìm kiếm nâng cao</v-list-item-title
              >
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon aria-label="Close" @click="closeMenuPopup"
                >mdi-close</v-icon
              >
            </v-col>
          </v-row>
          <v-divider style="margin-bottom: 20px"></v-divider>
          <v-row>
            <v-col v-if="nametab === BLENDED_TAB_INDEX.TASK">
              <v-row>
                <v-col cols="4" class="d-flex align-center">
                  Người thực hiện
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    @change="toggleSelectTeacher()"
                    v-model="innerFilterForm.userId"
                    :items="listGVCNV2"
                    item-text="name"
                    item-value="id"
                    no-data-text="Không có dữ liệu"
                    placeholder="Người thực hiện"
                    clearable
                    multiple
                    hide-details
                    persistent-placeholder
                    outlined
                    dense
                    chips
                    clear-icon="mdi-trash-can-outline"
                  >
                    <template #selection="{item}">
                      <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.userId, item.id)">
                        {{handleCutChipText(item.name)}}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="d-flex align-center">
                  Lịch hẹn
                </v-col>
                <v-col col="8">
                  <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    v-model="innerFilterForm.appointmentSchedule"
                    class="'show-date"
                    :class="currentPicker === 1 ? 'show-date' : 'hide-date'"
                    @show-date-picker="showDate(1)"
                    @check-close-on-click="checkCloseOnClick"
                    isFilter
                    noneMargin
                  ></common-range-picker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="d-flex align-center">
                  Loại công việc
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    v-model="innerFilterForm.type"
                    clearable
                    multiple
                    :items="LIST_TYPE_SELECT"
                    item-value="id"
                    item-text="text"
                    placeholder="Chọn loại công việc"
                    no-data-text="Không có dữ liệu"
                    persistent-placeholder
                    hide-details
                    dense
                    outlined
                    chips
                    clear-icon="mdi-trash-can-outline"
                  >
                    <template #selection="{item}">
                      <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.type, item.id)">
                        {{item.text}}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="$route.query.schoolLevel === 'secondary'">
                <v-col cols="4" class="d-flex align-center">
                  Khóa học
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    v-model="innerFilterForm.courseId"
                    :items="listCourse"
                    item-text="name"
                    item-value="id"
                    no-data-text="Không có dữ liệu"
                    placeholder="Chọn khoá học"
                    clearable
                    multiple
                    hide-details
                    dense
                    outlined
                    persistent-placeholder
                    chips
                    clear-icon="mdi-trash-can-outline"
                  >
                    <template #selection="{item}">
                      <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.courseId, item.id)">
                        {{handleCutChipText(item.name)}}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="d-flex align-center">
                  Trạng thái công việc
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    v-model="innerFilterForm.status"
                    clearable
                    multiple
                    :items="TASK_STATUS_OPTION"
                    item-value="id"
                    item-text="text"
                    placeholder="Chọn trạng thái công việc"
                    no-data-text="Không có dữ liệu"
                    persistent-placeholder
                    dense
                    outlined
                    hide-details
                    chips
                    clear-icon="mdi-trash-can-outline"
                  >
                    <template #selection="{item}">
                      <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.status, item.id)">
                        {{item.text}}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="d-flex align-center">
                  Chương trình (Tutor)
                </v-col>
                <v-col cols="8">
                  <v-autocomplete
                    v-model="innerFilterForm.curriculumId"
                    :items="listProgram"
                    item-text="title"
                    item-value="id"
                    placeholder="Chọn chương trình"
                    clearable
                    hide-details
                    persistent-placeholder
                    no-data-text="Không có dữ liệu"
                    multiple
                    dense
                    outlined
                    chips
                    clear-icon="mdi-trash-can-outline"
                  >
                    <template #selection="{item}">
                      <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.curriculumId, item.id)">
                        {{handleCutChipText(item.title)}}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-else>
              <v-row>
                <div style="max-height: 580px; width: 100%; overflow: auto" id="style-2">
                  <v-col cols="12">
                    <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin chăm sóc</div>
                    <v-row v-if="nametab !== BLENDED_TAB_INDEX.PERIODICALLY_CARE">
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Mốc gia hạn
                      </v-col>
                      <v-col cols="8">
                        <v-autocomplete
                          v-model="innerFilterForm.callStatusIds"
                          :items="nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR ? listCallStatusForSelectTutor : listCallStatusForSelectDuo"
                          item-text="name"
                          item-value="id"
                          placeholder="Chọn mốc"
                          clearable
                          hide-details
                          persistent-placeholder
                          no-data-text="Không có dữ liệu"
                          multiple
                          outlined
                          dense
                          chips
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template #selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.callStatusIds, item.id)">
                              {{item.name}}
                            </v-chip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Mốc chăm sóc
                      </v-col>
                      <v-col cols="8">
                        <v-autocomplete
                          v-model="innerFilterForm.callStatusIds"
                          :items="listStatusCSDK"
                          item-text="name"
                          item-value="id"
                          placeholder="Chọn mốc"
                          clearable
                          hide-details
                          persistent-placeholder
                          no-data-text="Không có dữ liệu"
                          multiple
                          outlined
                          dense
                          chips
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template #selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.callStatusIds, item.id)">
                              {{item.name}}
                            </v-chip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Quản lý lớp
                      </v-col>
                      <v-col cols="8">
                        <v-autocomplete
                          @change="toggleSelectTeacher()"
                          v-model="innerFilterForm.homeroomTeacherIds"
                          :items="listGVCNV2"
                          item-text="name"
                          item-value="id"
                          no-data-text="Không có dữ liệu"
                          :placeholder="
                      innerFilterForm.hasNoTeacher
                        ? 'Không có quản lý lớp'
                        : 'Chọn quản lý lớp'
                    "
                          clearable
                          multiple
                          hide-details
                          persistent-placeholder
                          outlined
                          dense
                          chips
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template #selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.homeroomTeacherIds, item.id)">
                              {{handleCutChipText(item.name)}}
                            </v-chip>
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item
                              ripple
                              @mousedown.prevent
                              @click="toggleHasNoTeacher"
                            >
                              <v-list-item-action>
                                <v-icon
                                  :color="
                              innerFilterForm.headTeacher.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                                >
                                  {{
                                    innerFilterForm.hasNoTeacher
                                      ? "mdi-checkbox-marked"
                                      : "mdi-checkbox-blank-outline"
                                  }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Không có quản lý lớp
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row >
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Sale gia hạn
                      </v-col>
                      <v-col cols="8">
                        <v-autocomplete
                          @change="toggleSelectSale()"
                          v-model="innerFilterForm.userIds"
                          :items="listSale"
                          item-text="fullName"
                          item-value="id"
                          :placeholder="
                      innerFilterForm.hasNoSale
                        ? 'Không có Sale gia hạn'
                        : 'Chọn Sale gia hạn'
                    "
                          no-data-text="Không có dữ liệu"
                          clearable
                          multiple
                          hide-details
                          persistent-placeholder
                          outlined
                          dense
                          chips
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template #selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.userIds, item.id)">
                              {{handleCutChipText(item.fullName)}}
                            </v-chip>
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item
                              ripple
                              @mousedown.prevent
                              @click="toggleHasNoSale"
                            >
                              <v-list-item-action>
                                <v-icon>
                                  {{
                                    innerFilterForm.hasNoSale
                                      ? "mdi-checkbox-marked"
                                      : "mdi-checkbox-blank-outline"
                                  }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Không có Sale gia hạn
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE">
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Số ngày chưa chăm sóc
                      </v-col>
                      <v-col cols="8">
                        <v-row>
                          <v-col cols="12">
                            <div class="d-flex">
                              <v-text-field
                                v-model="innerFilterForm.numberLastestCareDateFrom"
                                style="margin-top: 2px; padding-top: 0"
                                type="number"
                                min="0"
                                class="custom-input-number"
                                :class="required ? 'required' : ''"
                                outlined
                                dense
                                hide-details
                                @change="changeNumberLastCare('from')"
                              >
                                <template v-slot:prepend-inner>
                                  <div class="content-number d-flex align-center mt-1" :style="{color: required ? '#FF6B69' : ''}">Từ</div>
                                </template>
                                <template v-slot:append>
                                  <div class="mt-1 content-number" :style="{color: required ? '#FF6B69' : ''}">Ngày</div>
                                </template>
                              </v-text-field>
                              <v-text-field
                                v-model="innerFilterForm.numberLastestCareDateTo"
                                style="margin-top: 2px; padding-top: 0"
                                type="number"
                                class="custom-input-number ml-2"
                                :class="required ? 'required' : ''"
                                :min="innerFilterForm.numberLastestCareDateFrom"
                                @change="changeNumberLastCare('to')"
                                outlined
                                dense
                                hide-details
                              >
                                <template v-slot:prepend-inner>
                                  <div class="content-number d-flex align-center mt-1" :style="{color: required ? '#FF6B69' : ''}">Đến</div>
                                </template>
                                <template v-slot:append>
                                  <div class="mt-1 content-number" :style="{color: required ? '#FF6B69' : ''}">Ngày</div>
                                </template>
                              </v-text-field>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin học sinh</div>
                    <v-row v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE || nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">
                      <v-col cols="12" class="pl-6">
                        <v-checkbox
                          label="Chương trình học sinh không có hạn học"
                          v-model="innerFilterForm.isNullEndDate"
                          hide-details
                        >
                        </v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row v-if="nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR || nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE">
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Chương trình (Tutor)
                      </v-col>
                      <v-col cols="8">
                        <v-menu
                          bottom
                          offset-y
                          content-class="menu-wrapper-tree-user"
                          :close-on-content-click="false">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-if="(filterForm.programFilter.length === 0 && programFilterType === 1) || (filterForm.curriculumIds.length === 0 && programFilterType === 2)"
                              v-bind="attrs"
                              v-on="on">
                              <v-select
                                label="Chương trình (Tutor)"
                                readonly
                                hide-details
                                placeholder="Tìm kiếm theo chương trình "
                                outlined
                                dense
                              >
                              </v-select>
                            </div>
                            <div
                              v-bind="attrs"
                              v-on="on"
                              v-else
                              style="position: relative"
                            >
                              <div class="mt-1 tree-user-selected" v-show="programFilterType === 1">
                          <span
                            v-for="(node, index) in computedLevelName"
                            :key="node + index"
                          >
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                              {{ handleCutChipText(node, 30) }}
                            </v-chip>
                          </span>
                              </div>
                              <div class="mt-1 tree-user-selected" v-show="programFilterType === 2">
                                <span
                                  v-for="(node, index) in computedProgramName"
                                  :key="node + index"
                                >
                                  <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                                    {{ handleCutChipText(node, 30) }}
                                  </v-chip>
                                </span>
                              </div>
                              <v-icon
                                class="icon-clear-all"
                                color="grey"
                                @click="removeProgramLevelSelected()">mdi-trash-can-outline
                              </v-icon>
                            </div>
                          </template>
                          <template>
                            <div style="background: white; max-height: 400px; overflow: auto; padding: 0 12px">
                              <v-radio-group
                                style="justify-content: center"
                                class="custom-radio-group"
                                v-model="programFilterType"
                                row
                                hide-details
                              >
                                <v-radio
                                  label="Chọn theo level"
                                  :value="1"
                                ></v-radio>
                                <v-radio
                                  label="Chọn theo chương trình"
                                  :value="2"
                                ></v-radio>
                              </v-radio-group>
                              <v-text-field
                                class="px-6 pt-4"
                                label="Tìm kiếm..."
                                v-model="search"
                                hide-details
                              >
                              </v-text-field>
                              <v-treeview
                                v-show="programFilterType === 1"
                                v-model="filterForm.programFilter"
                                :search="search"
                                selectable
                                item-key="fakeId"
                                item-disabled="locked"
                                return-object
                                :items="treeListProgram"
                              ></v-treeview>
                              <v-treeview
                                v-show="programFilterType === 2"
                                v-model="filterForm.curriculumIds"
                                selectable
                                :items="listProgram"
                                :search="search"
                                item-text="title"
                                item-key="id"
                              ></v-treeview>
                            </div>
                          </template>
                        </v-menu>
                        <!--                  <v-autocomplete-->
                        <!--                    v-model="innerFilterForm.curriculumIds"-->
                        <!--                    :items="listProgram"-->
                        <!--                    item-text="title"-->
                        <!--                    item-value="id"-->
                        <!--                    label="Chương trình (Tutor)"-->
                        <!--                    placeholder="Chọn chương trình"-->
                        <!--                    clearable-->
                        <!--                    hide-details-->
                        <!--                    persistent-placeholder-->
                        <!--                    no-data-text="Không có dữ liệu"-->
                        <!--                    multiple-->
                        <!--                  />-->
                      </v-col>
                    </v-row>
                    <v-row v-if="nametab === BLENDED_TAB_INDEX.EXTEND_DUO || nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE">
                      <v-col cols="4"  class="d-flex align-center pl-6">
                        Môn học (Duo)
                      </v-col>
                      <v-col cols="8">
                        <v-autocomplete
                          v-model="innerFilterForm.subjectIds"
                          :items="listSubjectDuo"
                          item-text="name"
                          item-value="id"
                          placeholder="Chọn môn học"
                          clearable
                          hide-details
                          persistent-placeholder
                          no-data-text="Không có dữ liệu"
                          multiple
                          dense
                          outlined
                          chips
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template #selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.subjectIds, item.id)">
                              {{handleCutChipText(item.name)}}
                            </v-chip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Sản phẩm
                      </v-col>
                      <v-col cols="8">
                        <v-autocomplete
                          v-model="innerFilterForm.productIds"
                          :items="productList"
                          item-text="name"
                          item-value="id"
                          placeholder="Chọn sản phẩm"
                          no-data-text="Không có dữ liệu"
                          clearable
                          multiple
                          hide-details
                          persistent-placeholder
                          outlined
                          dense
                          chips
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template #selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.productIds, item.id)">
                              {{handleCutChipText(item.name)}}
                            </v-chip>
                          </template>
                        </v-autocomplete>
                      </v-col>

                    </v-row>
                    <v-row>
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Mã lớp
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                          v-model="innerFilterForm.classCode"
                          label="Mã lớp học"
                          placeholder="Nhập mã lớp"
                          clearable
                          hide-details
                          dense
                          outlined
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE || nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Trạng thái học viên (Tutor)
                      </v-col>
                      <v-col cols="8">
                        <v-autocomplete
                          v-model="innerFilterForm.studentStatusTutor"
                          :items="HS_STATUSES ? HS_STATUSES : []"
                          item-text="name"
                          item-value="id"
                          placeholder="Chọn trạng thái"
                          no-data-text="Không có dữ liệu"
                          clearable
                          multiple
                          hide-details
                          persistent-placeholder
                          outlined
                          dense
                          chips
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template #selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.studentStatusTutor, item.id)">
                              {{item.name}}
                            </v-chip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE || nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Số buổi đã học
                      </v-col>
                      <v-col cols="8">
                        <!--                      <span class="content-fil">Số đã học <v-icon style="font-size:14px" title="Chỉ áp dụng lọc cho Tutor">mdi-information-outline</v-icon></span>-->
                        <v-row>
                          <v-col cols="12" md="5" class="pr-0 custom-font-input">
                            <v-select
                              v-model="innerFilterForm.typeLessonPassed"
                              :items="typeNumberOfLearnTrial"
                              item-text="label"
                              item-value="value"
                              hide-details
                              dense
                              outlined
                            />
                          </v-col>
                          <v-col cols="12" md="7" class="custom-font-input">
                            <v-text-field
                              type="number"
                              min="0"
                              placeholder="Nhập số buổi học"
                              v-model="innerFilterForm.numberLessonPassed"
                              @keyup.native="changenumberOfLearnTrial($event, 'numberLessonPassed')"
                              hide-details
                              dense
                              outlined
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thời gian</div>
                    <v-row v-if="nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Ngày chuyển mốc chuyển sale
                      </v-col>
                      <v-col cols="8">
                        <common-range-picker
                          :disabled="true"
                          :clearable="true"
                          :aLight="'left'"
                          v-model="innerFilterForm.extend_sale_at"
                          @check-close-on-click="checkCloseOnClick"
                          class="show-date"
                          isFilter
                          noneMargin
                        ></common-range-picker>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Ngày hết hạn
                      </v-col>
                      <v-col cols="8">
                        <common-range-picker
                          :disabled="true"
                          :clearable="true"
                          :aLight="'left'"
                          v-model="innerFilterForm.endDate"
                          @check-close-on-click="checkCloseOnClick"
                          class="show-date"
                          isFilter
                          noneMargin
                        ></common-range-picker>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE">
                    <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Khác</div>
                    <v-row>
                      <v-col cols="4" class="d-flex align-center pl-6">
                        Tag
                      </v-col>
                      <v-col cols="8">
                        <v-select
                          multiple
                          v-model="filterForm.tags"
                          outlined
                          dense
                          hide-details
                          chips
                          :items="computedTagOption"
                          clearable
                          clear-icon="mdi-trash-can-outline"
                        >
                          <template v-slot:selection="{item}">
                            <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.tags, item.value)">
                              {{item.text}}
                            </v-chip>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                </div>
<!--                <template v-else>-->
<!--                  <v-col cols="12" md="4">-->
<!--                    <v-autocomplete-->
<!--                      @change="toggleSelectTeacher()"-->
<!--                      v-model="innerFilterForm.homeroomTeacherIds"-->
<!--                      :items="listGVCNV2"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      no-data-text="Không có dữ liệu"-->
<!--                      label="Quản lý lớp"-->
<!--                      :placeholder="-->
<!--                      innerFilterForm.hasNoTeacher-->
<!--                        ? 'Không có quản lý lớp'-->
<!--                        : 'Chọn quản lý lớp'-->
<!--                    "-->
<!--                      clearable-->
<!--                      multiple-->
<!--                      hide-details-->
<!--                      persistent-placeholder-->
<!--                    >-->
<!--                      <template v-slot:prepend-item>-->
<!--                        <v-list-item-->
<!--                          ripple-->
<!--                          @mousedown.prevent-->
<!--                          @click="toggleHasNoTeacher"-->
<!--                        >-->
<!--                          <v-list-item-action>-->
<!--                            <v-icon-->
<!--                              :color="-->
<!--                              innerFilterForm.headTeacher.length > 0-->
<!--                                ? 'indigo darken-4'-->
<!--                                : ''-->
<!--                            "-->
<!--                            >-->
<!--                              {{-->
<!--                                innerFilterForm.hasNoTeacher-->
<!--                                  ? "mdi-checkbox-marked"-->
<!--                                  : "mdi-checkbox-blank-outline"-->
<!--                              }}-->
<!--                            </v-icon>-->
<!--                          </v-list-item-action>-->
<!--                          <v-list-item-content>-->
<!--                            <v-list-item-title>-->
<!--                              Không có quản lý lớp-->
<!--                            </v-list-item-title>-->
<!--                          </v-list-item-content>-->
<!--                        </v-list-item>-->
<!--                        <v-divider class="mt-2"></v-divider>-->
<!--                      </template>-->
<!--                    </v-autocomplete>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4" v-if="nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR || nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE">-->
<!--                    <v-menu-->
<!--                      bottom-->
<!--                      offset-y-->
<!--                      content-class="menu-wrapper-tree-user"-->
<!--                      :close-on-content-click="false">-->
<!--                      <template v-slot:activator="{ on, attrs }">-->
<!--                        <div-->
<!--                          v-if="(filterForm.programFilter.length === 0 && programFilterType === 1) || (filterForm.curriculumIds.length === 0 && programFilterType === 2)"-->
<!--                          v-bind="attrs"-->
<!--                          v-on="on">-->
<!--                          <v-select-->
<!--                            label="Chương trình (Tutor)"-->
<!--                            readonly-->
<!--                            hide-details-->
<!--                            placeholder="Tìm kiếm theo chương trình "-->
<!--                          >-->
<!--                          </v-select>-->
<!--                        </div>-->
<!--                        <div-->
<!--                          v-bind="attrs"-->
<!--                          v-on="on"-->
<!--                          v-else-->
<!--                          style="position: relative"-->
<!--                        >-->
<!--                          <div style="font-size: 10px">Chương trình</div>-->
<!--                          <div class="mt-1 tree-user-selected" v-show="programFilterType === 1">-->
<!--                          <span-->
<!--                            v-for="(node, index) in computedLevelName"-->
<!--                            :key="node"-->
<!--                          >-->
<!--                            {{ node }}-->
<!--                            <span v-if="index < computedLevelName.length - 1">, </span>-->
<!--                          </span>-->
<!--                          </div>-->
<!--                          <div class="mt-1 tree-user-selected" v-show="programFilterType === 2">-->
<!--                          <span-->
<!--                            v-for="(node, index) in computedProgramName"-->
<!--                            :key="node"-->
<!--                          >-->
<!--                            {{ node }}-->
<!--                            <span v-if="index < computedProgramName.length -1">, </span>-->
<!--                          </span>-->
<!--                          </div>-->
<!--                          <v-icon-->
<!--                            class="icon-clear-all"-->
<!--                            color="grey"-->
<!--                            @click="removeProgramLevelSelected()">mdi-window-close-->
<!--                          </v-icon>-->
<!--                        </div>-->
<!--                      </template>-->
<!--                      <template>-->
<!--                        <div style="background: white; max-height: 400px; overflow: auto; padding: 0 12px">-->
<!--                          <v-radio-group-->
<!--                            style="justify-content: center"-->
<!--                            class="custom-radio-group"-->
<!--                            v-model="programFilterType"-->
<!--                            row-->
<!--                            hide-details-->
<!--                          >-->
<!--                            <v-radio-->
<!--                              label="Chọn theo level"-->
<!--                              :value="1"-->
<!--                            ></v-radio>-->
<!--                            <v-radio-->
<!--                              label="Chọn theo chương trình"-->
<!--                              :value="2"-->
<!--                            ></v-radio>-->
<!--                          </v-radio-group>-->
<!--                          <v-text-field-->
<!--                            class="px-6 pt-4"-->
<!--                            label="Tìm kiếm..."-->
<!--                            v-model="search"-->
<!--                            hide-details-->
<!--                          >-->
<!--                          </v-text-field>-->
<!--                          <v-treeview-->
<!--                            v-show="programFilterType === 1"-->
<!--                            v-model="filterForm.programFilter"-->
<!--                            :search="search"-->
<!--                            selectable-->
<!--                            item-key="fakeId"-->
<!--                            item-disabled="locked"-->
<!--                            return-object-->
<!--                            :items="treeListProgram"-->
<!--                          ></v-treeview>-->
<!--                          <v-treeview-->
<!--                            v-show="programFilterType === 2"-->
<!--                            v-model="filterForm.curriculumIds"-->
<!--                            selectable-->
<!--                            :items="listProgram"-->
<!--                            :search="search"-->
<!--                            item-text="title"-->
<!--                            item-key="id"-->
<!--                          ></v-treeview>-->
<!--                        </div>-->
<!--                      </template>-->
<!--                    </v-menu>-->
<!--                    &lt;!&ndash;                  <v-autocomplete&ndash;&gt;-->
<!--                    &lt;!&ndash;                    v-model="innerFilterForm.curriculumIds"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    :items="listProgram"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    item-text="title"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    item-value="id"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    label="Chương trình (Tutor)"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    placeholder="Chọn chương trình"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    clearable&ndash;&gt;-->
<!--                    &lt;!&ndash;                    hide-details&ndash;&gt;-->
<!--                    &lt;!&ndash;                    persistent-placeholder&ndash;&gt;-->
<!--                    &lt;!&ndash;                    no-data-text="Không có dữ liệu"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    multiple&ndash;&gt;-->
<!--                    &lt;!&ndash;                  />&ndash;&gt;-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4" v-if="nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">-->
<!--                    <common-range-picker-->
<!--                      :clearable="true"-->
<!--                      :aLight="'left'"-->
<!--                      v-model="innerFilterForm.extend_sale_at"-->
<!--                      class="show-date"-->
<!--                      label="Ngày chuyển qua mốc chuyển sale"-->
<!--                    ></common-range-picker>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4" v-if=" nametab === BLENDED_TAB_INDEX.EXTEND_DUO || nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE">-->
<!--                    <v-autocomplete-->
<!--                      v-model="innerFilterForm.subjectIds"-->
<!--                      :items="listSubjectDuo"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      label="Môn học (Duo)"-->
<!--                      placeholder="Chọn môn học"-->
<!--                      clearable-->
<!--                      hide-details-->
<!--                      persistent-placeholder-->
<!--                      no-data-text="Không có dữ liệu"-->
<!--                      multiple-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4">-->
<!--                    <v-autocomplete-->
<!--                      @change="toggleSelectSale()"-->
<!--                      v-model="innerFilterForm.userIds"-->
<!--                      :items="listSale"-->
<!--                      item-text="fullName"-->
<!--                      item-value="id"-->
<!--                      label="Sale gia hạn"-->
<!--                      :placeholder="-->
<!--                      innerFilterForm.hasNoSale-->
<!--                        ? 'Không có Sale gia hạn'-->
<!--                        : 'Chọn Sale gia hạn'-->
<!--                    "-->
<!--                      no-data-text="Không có dữ liệu"-->
<!--                      clearable-->
<!--                      multiple-->
<!--                      hide-details-->
<!--                      persistent-placeholder-->
<!--                    >-->
<!--                      <template v-slot:prepend-item>-->
<!--                        <v-list-item-->
<!--                          ripple-->
<!--                          @mousedown.prevent-->
<!--                          @click="toggleHasNoSale"-->
<!--                        >-->
<!--                          <v-list-item-action>-->
<!--                            <v-icon>-->
<!--                              {{-->
<!--                                innerFilterForm.hasNoSale-->
<!--                                  ? "mdi-checkbox-marked"-->
<!--                                  : "mdi-checkbox-blank-outline"-->
<!--                              }}-->
<!--                            </v-icon>-->
<!--                          </v-list-item-action>-->
<!--                          <v-list-item-content>-->
<!--                            <v-list-item-title>-->
<!--                              Không có Sale gia hạn-->
<!--                            </v-list-item-title>-->
<!--                          </v-list-item-content>-->
<!--                        </v-list-item>-->
<!--                        <v-divider class="mt-2"></v-divider>-->
<!--                      </template>-->
<!--                    </v-autocomplete>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4" v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE">-->
<!--                    <span class="content-fil">Số ngày chưa chăm sóc-->
<!--                    <v-tooltip bottom >-->
<!--                      <template #activator="{on, attrs}">-->
<!--                        <v-icon v-on="on" v-bind="attrs" style="font-size: 14px" class="ml-2">-->
<!--                          mdi-information-outline-->
<!--                        </v-icon>-->
<!--                      </template>-->
<!--                      <div>-->
<!--                        Tìm kiếm những học viên có số ngày chưa được chăm sóc-->
<!--                        <br>-->
<!--                        tính từ lần chăm sóc gần nhất của học viên đó.-->
<!--                      </div>-->
<!--                    </v-tooltip>-->
<!--                      <v-tooltip v-if="required" bottom >-->
<!--                        <template #activator="{on, attrs}">-->
<!--                          <v-icon v-on="on" v-bind="attrs" style="font-size: 14px" class="ml-2" color="#FF6B69">-->
<!--                            mdi-alert-circle-outline-->
<!--                          </v-icon>-->
<!--                        </template>-->
<!--                        <div>-->
<!--                          Số nhập tại ô “đến…” phải lớn hơn bằng số nhập ở “Từ…”-->
<!--                        </div>-->
<!--                      </v-tooltip>-->
<!--                    </span>-->
<!--                    <v-row>-->
<!--                      <v-col cols="12">-->
<!--                        <div class="d-flex">-->
<!--                          <div class="mt-3 mr-2 content-number" :style="{color: required ? '#FF6B69' : ''}">Từ</div>-->
<!--                          <v-text-field-->
<!--                            v-model="innerFilterForm.numberLastestCareDateFrom"-->
<!--                            style="margin-top: 2px; padding-top: 0"-->
<!--                            type="number"-->
<!--                            min="0"-->
<!--                            class="custom-input-number"-->
<!--                            :class="required ? 'required' : ''"-->
<!--                            @change="changeNumberLastCare('from')"-->
<!--                          ></v-text-field>-->
<!--                          <div class="mt-3 mx-2 content-number" :style="{color: required ? '#FF6B69' : ''}">Đến</div>-->
<!--                          <v-text-field-->
<!--                            v-model="innerFilterForm.numberLastestCareDateTo"-->
<!--                            style="margin-top: 2px; padding-top: 0"-->
<!--                            type="number"-->
<!--                            class="custom-input-number"-->
<!--                            :class="required ? 'required' : ''"-->
<!--                            :min="innerFilterForm.numberLastestCareDateFrom"-->
<!--                            @change="changeNumberLastCare('to')"-->
<!--                          ></v-text-field>-->
<!--                        </div>-->
<!--                      </v-col>-->
<!--                    </v-row>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4">-->
<!--                    <v-autocomplete-->
<!--                      v-model="innerFilterForm.productIds"-->
<!--                      :items="productList"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      label="Sản phẩm"-->
<!--                      placeholder="Chọn sản phẩm"-->
<!--                      no-data-text="Không có dữ liệu"-->
<!--                      clearable-->
<!--                      multiple-->
<!--                      hide-details-->
<!--                      persistent-placeholder-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4">-->
<!--                    <common-range-picker-->
<!--                      :disabled="true"-->
<!--                      :clearable="true"-->
<!--                      :aLight="'left'"-->
<!--                      v-model="innerFilterForm.endDate"-->
<!--                      class="show-date"-->
<!--                      label="Ngày hết hạn"-->
<!--                    ></common-range-picker>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4" v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE || nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">-->
<!--                    <span class="content-fil">Số đã học <v-icon style="font-size:14px" title="Chỉ áp dụng lọc cho Tutor">mdi-information-outline</v-icon></span>-->
<!--                    <v-row>-->
<!--                      <v-col cols="12" md="5" class="pr-0 custom-font-input">-->
<!--                        <v-select-->
<!--                          v-model="innerFilterForm.typeLessonPassed"-->
<!--                          :items="typeNumberOfLearnTrial"-->
<!--                          item-text="label"-->
<!--                          item-value="value"-->
<!--                          hide-details-->
<!--                        />-->
<!--                      </v-col>-->
<!--                      <v-col cols="12" md="7" class="custom-font-input">-->
<!--                        <v-text-field-->
<!--                          type="number"-->
<!--                          min="0"-->
<!--                          placeholder="Nhập số buổi học"-->
<!--                          v-model="innerFilterForm.numberLessonPassed"-->
<!--                          @keyup.native="changenumberOfLearnTrial($event, 'numberLessonPassed')"-->
<!--                          hide-details-->
<!--                        >-->
<!--                        </v-text-field>-->
<!--                      </v-col>-->
<!--                    </v-row>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4">-->
<!--                    <v-text-field-->
<!--                      v-model="innerFilterForm.classCode"-->
<!--                      label="Mã lớp học"-->
<!--                      placeholder="Nhập mã lớp"-->
<!--                      clearable-->
<!--                      hide-details-->
<!--                      persistent-placeholder-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4" v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE || nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">-->
<!--                    <v-autocomplete-->
<!--                      v-model="innerFilterForm.studentStatusTutor"-->
<!--                      :items="HS_STATUSES ? HS_STATUSES : []"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      label="Trạng thái học viên (Tutor)"-->
<!--                      placeholder="Chọn trạng thái"-->
<!--                      no-data-text="Không có dữ liệu"-->
<!--                      clearable-->
<!--                      multiple-->
<!--                      hide-details-->
<!--                      persistent-placeholder-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="4" v-if="nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE || nametab === BLENDED_TAB_INDEX.EXTEND_TUTOR">-->
<!--                    <v-checkbox-->
<!--                      label="Không có hạn"-->
<!--                      v-model="innerFilterForm.isNullEndDate"-->
<!--                    >-->
<!--                    </v-checkbox>-->
<!--                  </v-col>-->
<!--                </template>-->
                <!-- //TODO: Code for two face -->
              </v-row>
            </v-col>
          </v-row>
          <v-divider style="margin-bottom: 20px; margin-top: 20px"></v-divider>
          <div class="text-center mb-4">
            <v-btn class="primary mx-2" @click="searchContact" style="background-color: #E91E63 !important">
              Áp dụng bộ lọc
            </v-btn>
<!--            <v-btn v-if="checkAuthorization(downloadPermission) && nametab !== BLENDED_TAB_INDEX.TASK" class="primary mx-2" @click="downloadExcel()" >-->
<!--              <v-icon>mdi-download</v-icon>Download-->
<!--            </v-btn>-->
            <v-menu offset-y>
              <template v-slot:activator="{on, attrs}">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  class="primary mx-2"
                  v-show="isShowDownloadBtn"
                >
                  <v-icon>mdi-download</v-icon>
                  Download
                </v-btn>
              </template>
              <v-list>
                <v-list-item-group>
                  <v-list-item>
                    <img src="../../student_care/assets/download-excel-icon.svg" alt="" class="mr-3">
                    <v-list-item-title
                      @click="downloadExcel()"
                    >Download File thường</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="isShowTransactionDownload">
                    <img src="../../student_care/assets/download-transaction-icon.svg" alt="" class="mr-3">
                    <v-list-item-title @click="downloadReportTransaction()">Download file theo đơn hàng</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-card>
</template>
<script>
import {
  HS_STATUSES, HS_STATUSES_DUO, SCHOOL_LEVEL, TYPE_CURRICULUM_OBJ,
} from '@/helpers/constant';
import { mapActions, mapState } from 'vuex';
import RepositoryFactory from '@/services/RepositoryFactory';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import StudentCareServices from '@/services/StudentCareServices';
import { TAG_OPTIONS } from '@/modules/student_care/constant/constant';
import {
  LIST_TYPE_SELECT,
  LEVEL_DEFAULT,
  LEVEL_ENGLISH,
  downloadPermissionTab,
  extendTutorBlendedPermission,
  extendTutorBlendedPermissionToTab,
  BLENDED_TAB_INDEX,
  LIST_TYPE,
  TASK_STATUS_OPTION,
  downloadPermissionTabSecondary,
} from '@/modules/blended/const';

const ProductRepository = RepositoryFactory.get('product');
const ContactRepository = RepositoryFactory.get('contact');
const CallStatusRepository = RepositoryFactory.get('call_status');

export default {
  props: {
    tutorPriority: {
      type: Number,
      default: 0,
    },
    nametab: {
      type: Number,
      default: 0,
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      SCHOOL_LEVEL,
      LIST_TYPE_SELECT,
      LIST_TYPE,
      TASK_STATUS_OPTION,
      BLENDED_TAB_INDEX,
      search: '',
      programFilterType: 1,
      typeSearchLatestDate: [
        {
          value: 'eq',
          label: 'Bằng',
        },
        {
          value: 'gte',
          label: 'Lớn hơn hoặc bằng',
        },
        {
          value: 'gt',
          label: 'Lớn hơn',
        },
      ],
      innerFilterForm: {},
      inline: null,
      listUser: [],
      productList: [],
      typeNumberOfLearnTrial: [
        {
          label: 'Bằng',
          value: 'eq',
        },
        {
          label: 'Lớn hơn',
          value: 'gt',
        },
        {
          label: 'Nhỏ hơn',
          value: 'lt',
        },
      ],
      typeNumberOfNewLearnTrial: [
        {
          label: 'Bằng',
          value: 'eq',
        },
        {
          label: 'Lớn hơn',
          value: 'gt',
        },
      ],
      listStatusCSDK: [],
      listCallStatusForSelectTutor: [],
      listCallStatusForSelectDuo: [],
      HS_STATUSES,
      HS_STATUSES_DUO,
      listSubjectDuo: [],
      downloadPermissionTab,
      currentPicker: null,
      required: false,
      listCourse: [],

    };
  },
  async created() {
    this.innerFilterForm = _.cloneDeep(this.filterForm);
    this.getListGVCN();
    this.getListGVCNV2();
    this.getListProduct();
    this.getListUser();
    this.listStatusCSDK = await this.getListCallStatusCSDK();
    this.listCallStatusForSelectDuo = await this.getListCallStatusDuo();
    this.listCallStatusForSelectTutor = await this.getListCallStatusTutor();
    if (this.listProgram && !this.listProgram.length) {
      this.getListProgram();
    }
    this.getSubjectDuo();
    this.getListCourse();
  },
  watch: {
    programFilterType(val) {
      if (val === 1) {
        this.filterForm.curriculumIds = [];
      } else {
        this.filterForm.programFilter = [];
      }
    },
    'filterForm.programFilter': function (val, oldVal) {
      if (val.length > 10) {
        this.$swal.fire({
          title: 'Thông báo',
          text: 'Chỉ được tối đa 10 tick chọn tại lọc Level',
          icon: 'warning',
        }).then(() => {
          this.filterForm.programFilter = _.cloneDeep(oldVal);
          setTimeout(() => {
            this.filter.closeMenu = true;
          }, 200);
        });
      }
    },
    filterForm: {
      handler(val) {
        this.innerFilterForm = _.cloneDeep(val);
      },
      deep: true,
    },
    'innerFilterForm.isNullEndDate': {
      handler(val) {
        if (val) this.innerFilterForm.endDate = null;
      },
    },
    'innerFilterForm.endDate': {
      handler(val) {
        if (val && val.length) this.innerFilterForm.isNullEndDate = false;
      },
    },
  },
  computed: {
    ...mapState('student_care', ['listGVCN', 'listGVCNV2', 'listProgram', 'listSale']),
    computedTagOption() {
      if (this.$route.query.schoolLevel === SCHOOL_LEVEL.PRIMARY) {
        return TAG_OPTIONS.BLENDED_PRIMARY;
      }
      if (this.$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY) {
        return TAG_OPTIONS.BLENDED_SECONDARY;
      }
      return [];
    },
    isShowDownloadBtn() {
      return this.checkAuthorization(this.downloadPermission) && this.nametab !== BLENDED_TAB_INDEX.TASK;
    },
    isShowTransactionDownload() {
      return this.nametab === BLENDED_TAB_INDEX.PERIODICALLY_CARE;
    },
    downloadPermission() {
      // eslint-disable-next-line no-nested-ternary
      const permission = this.$route.query.schoolLevel === SCHOOL_LEVEL.PRIMARY ? downloadPermissionTab : this.$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY ? downloadPermissionTabSecondary : [];
      return permission[this.nametab];
    },
    computedLevelName() {
      return this.filterForm.programFilter.map((e) => e.programLevelName);
    },
    computedProgramName() {
      return this.listProgram.filter((e) => this.filterForm.curriculumIds.includes(e.id)).map((e) => e.title);
    },
    treeListProgram() {
      let result = [];
      result = _.cloneDeep(this.listProgram);
      result.forEach((e) => {
        e.name = e.title;
        e.fakeId = e.id.toString();
        if (e.subject_id === 3) {
          e.children = _.cloneDeep(LEVEL_ENGLISH);
          e.children.forEach((child) => {
            // eslint-disable-next-line no-param-reassign,radix
            child.fakeId = `${e.id.toString()}_${child.id.toString()}`;
            if (child.children) {
              child.children.forEach((grandChild) => {
                // eslint-disable-next-line no-param-reassign,radix
                grandChild.fakeId = `${e.id.toString()}_${child.id.toString()}_${grandChild.id.toString()}`;
                // eslint-disable-next-line no-param-reassign
                grandChild.programLevelName = `${e.name} - ${child.name} - ${grandChild.name}`;
              });
            } else {
              // eslint-disable-next-line no-param-reassign
              child.programLevelName = `${e.name} - ${child.name}`;
            }
          });
        } else if (e.subject_id !== 15) {
          e.children = _.cloneDeep(LEVEL_DEFAULT);
          e.children.forEach((child) => {
            // eslint-disable-next-line no-param-reassign,radix
            child.fakeId = `${e.id.toString()}_${child.id.toString()}`;
            // eslint-disable-next-line no-param-reassign
            child.programLevelName = `${e.name} - ${child.name}`;
          });
        } else {
          e.programLevelName = `${e.name}`;
          e.fakeId = e.id.toString();
        }
      });
      return result;
    },
  },
  methods: {
    ...mapActions('student_care', ['getListGVCN', 'getListProgram', 'getListGVCNV2']),
    handleCutChipText(text, number = 20) {
      return text.length > number ? `${text.slice(0, number - 2)}...` : text;
    },
    checkCloseOnClick(val) {
      this.$emit('change-close-on-click', !val);
    },
    removeItemProgram(node, programFilterType, index) {
      // eslint-disable-next-line no-unused-expressions
      programFilterType === 1 ? this.filterForm.programFilter.splice(index, 1) : this.filterForm.curriculumIds.splice(index, 1);
    },
    removeItem(items, item) {
      const index = items.indexOf(item);
      if (index >= 0) items.splice(index, 1);
    },
    async downloadReportTransaction() {
      Bus.$emit('download-excel-filter-data-blended-transaction', {
        school_level: this.$route.query.schoolLevel,
        typeBlended: this.tutorPriority,
        ...this.innerFilterForm,
      });
    },
    removeProgramLevelSelected() {
      if (this.programFilterType === 1) {
        this.filterForm.programFilter = [];
      } else {
        this.filterForm.curriculumIds = [];
      }
    },
    closeMenuPopup() {
      this.$emit('close');
    },
    searchContact() {
      if (this.required) return;
      if ((!this.innerFilterForm.numberLastestCareDateFrom && this.innerFilterForm.numberLastestCareDateTo) || (!this.innerFilterForm.numberLastestCareDateTo && this.innerFilterForm.numberLastestCareDateFrom)) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng nhập đủ khoảng ngày chưa chăm sóc!',
        });
        return;
      }
      const diffDays = this.innerFilterForm.endDate && this.innerFilterForm.endDate.length ? parseInt((new Date(this.innerFilterForm.endDate[1]) - new Date(this.innerFilterForm.endDate[0])) / (1000 * 60 * 60 * 24), 10) : null;
      if (diffDays && Math.abs(diffDays) > 30 && this.nametab === BLENDED_TAB_INDEX.EXTEND_DUO) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Chỉ tìm kiếm được tối đa trong vòng 30 ngày !!',
        });
      } else {
        this.$emit('searchContact', this.innerFilterForm);
      }
    },
    async getListCallStatusCSDK() {
      const c0 = await this.getListStatusForType({ typeCustomerCare: [4, 1], type_curriculum: TYPE_CURRICULUM_OBJ.ONLINE });
      if (c0) {
        const listCallStatus = [];
        c0.forEach((call) => {
          listCallStatus.push({
            header: `BT${call.name.substring(2)}`,
          });
          listCallStatus.push(...call.data);
        });
        return listCallStatus;
      }
      return [];
    },
    async getListCallStatusTutor() {
      const typeCustomerCare = _.intersection(extendTutorBlendedPermission, this.$store.state.permissions).map((per) => extendTutorBlendedPermissionToTab[per]);
      const listGiaHan = await this.getListStatusForType({ typeCustomerCare, type_curriculum: TYPE_CURRICULUM_OBJ.ONLINE });
      if (listGiaHan) {
        const listCallStatus = [];
        listGiaHan.forEach((call) => {
          listCallStatus.push({
            header: `BT${call.name.substring(2)}`,
          });
          listCallStatus.push(...call.data);
        });
        return listCallStatus;
      }
      return [];
    },
    async getListCallStatusDuo() {
      const listGiaHan = await this.getListStatusForType({ typeCustomerCare: 2, type_curriculum: TYPE_CURRICULUM_OBJ.DUO });
      if (listGiaHan) {
        const listCallStatus = [];
        listGiaHan.forEach((call) => {
          listCallStatus.push({
            header: `BT - ${call.name.substring(0)}`,
          });
          listCallStatus.push(...call.data);
        });
        return listCallStatus;
      }
      return [];
    },
    async getListStatusForType(params) {
      const response = await CallStatusRepository.getStatusList(params);
      if (response && response.data) {
        return response.data;
      }
      return [];
    },
    async getListProduct() {
      const res = await ProductRepository.getList({
        limit: 1000,
        status: 'active',
      });
      if (res?.success) {
        this.productList = res?.data;
      }
    },
    toggleHasNoTeacher() {
      this.$nextTick(() => {
        this.innerFilterForm.hasNoTeacher = !this.innerFilterForm.hasNoTeacher;
        this.innerFilterForm.homeroomTeacherIds = [];
      });
    },
    toggleSelectTeacher() {
      this.searchInputTeacher = '';
      this.$nextTick(() => {
        if (this.innerFilterForm.homeroomTeacherIds.length > 0) {
          this.innerFilterForm.hasNoTeacher = false;
        }
      });
    },
    toggleHasNoSale() {
      this.$nextTick(() => {
        this.innerFilterForm.hasNoSale = !this.innerFilterForm.hasNoSale;
        this.innerFilterForm.userIds = [];
      });
    },
    toggleSelectSale() {
      this.searchInputSale = '';
      this.$nextTick(() => {
        if (this.innerFilterForm.userIds.length > 0) {
          this.innerFilterForm.hasNoSale = false;
        }
      });
    },
    async getListUser() {
      const res = await ContactRepository.getListUser();
      if (res?.success) {
        const personInCharges = [];
        // eslint-disable-next-line no-unused-expressions
        res?.data.forEach((ministry) => {
          const { users = [] } = ministry;
          if (users.length) {
            personInCharges.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach((user) => {
              personInCharges.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.listUser = personInCharges;
      }
    },
    changenumberOfLearnTrial(event, key) {
      if (event.target.valueAsNumber < 0) {
        this.innerFilterForm[`${key}`] = 0;
      }
      if (!Number.isInteger(event.target.valueAsNumber)) {
        this.innerFilterForm[`${key}`] = Math.floor(event.target.valueAsNumber);
      }
    },
    async downloadExcel() {
      this.$emit('export', this.innerFilterForm);
    },
    async getSubjectDuo() {
      const res = await BlendedCareRepository.getSubjectDuo();
      if (res && res.data) {
        this.listSubjectDuo = res.data;
      }
      if (res && res.error) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra !!!',
        });
      }
      return 0;
    },
    showDate(index) {
      this.currentPicker = index;
    },
    changeNumberLastCare(type) {
      if (!(Number.isInteger(Number(this.innerFilterForm.numberLastestCareDateFrom)) && Number(this.innerFilterForm.numberLastestCareDateFrom) > 0)) this.innerFilterForm.numberLastestCareDateFrom = null;
      if (!(Number.isInteger(Number(this.innerFilterForm.numberLastestCareDateTo)) && Number(this.innerFilterForm.numberLastestCareDateTo) > 0)) this.innerFilterForm.numberLastestCareDateTo = null;
      if ((type === 'from' && Number(this.innerFilterForm.numberLastestCareDateFrom) > Number(this.innerFilterForm.numberLastestCareDateTo) && this.innerFilterForm.numberLastestCareDateTo !== null) || (type === 'to' && Number(this.innerFilterForm.numberLastestCareDateTo) < Number(this.innerFilterForm.numberLastestCareDateFrom) && this.innerFilterForm.numberLastestCareDateFrom !== null)) {
        this.required = true;
      } else {
        this.required = false;
      }
    },
    async getListCourse() {
      const res = await StudentCareServices.getListCourse();
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.listCourse = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font-size: 14px;
}
.content-fil {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
<style lang="scss">
.custom-font-input {
  .v-input.v-input--hide-details {
    padding-top: 0px;
    margin: 0;
  }
}
.icon-clear-all {
  position: absolute !important;
  right: 15px;
  top: 20px;
  /*background: white;*/
}
.tree-user-selected {
  min-height: 34px;
  overflow-y: auto;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  column-gap: 4px;
  padding: 8px 40px 8px 8px;
}
.custom-input-number {
  .v-text-field__slot {
    input {
      padding: 0px 0px 0px 4px;
      text-align: center;
    }
  }
  &.required {
    .v-text-field__slot {
      input {
        color: #FF6B69 !important;
      }
    }
  }
}
</style>
